export class ChaseInvoiceStatus {
    transactionId: string;
    orderId: string;
    invoiceIds: string;
    amountPaid: string;
    transactionStatus: string;
    paymentMode: string;
}
